export enum SubjectOptions {
    REQUEST_FOR_ADDITIONAL_INFORMATION = 'Request For Additional Information',
    POTENTIAL_ADVERSE_DETERMINATION = 'Potential Adverse Determination',
    OTHER = 'Other'
}